// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    appName: "LGBT",
    intitials: "LGBT",

    login_image: "login-v2.svg",
    login_image_dark: "login-v2-dark.svg",

    register_image: "register-v2.svg",
    register_image_dark: "register-v2-dark.svg",

    password_image: "forgot-password-v2.svg",
    password_image_dark: "forgot-password-v2-dark.svg",

    error_image: "error.svg",
    error_image_dark: "error-dark.svg",

    appLogoImage: require("@src/assets/images/logo/logo.png").default
  },
  layout: {
    isRTL: false,
    skin: "light", // light, dark, bordered, semi-dark
    type: "vertical", // vertical, horizontal
    contentWidth: "boxed", // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "floating", // static , sticky , floating, hidden
      backgroundColor: "white" // BS color options [primary, success, etc]
    },
    footer: {
      type: "static" // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button
    toastPosition: "top-right" // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
  }
}

export default themeConfig
